import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputError from '../../../errors/InputError';
import "./TextArea.css";

export default class TextArea extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: (this.props.existingContent) ? this.props.existingContent : ""
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if ('existingContent' in newProps && newProps.existingContent !== undefined && newProps.existingContent !== this.state.value) {
      this.setState({ value: newProps.existingContent });
    }
  }

  getValue = () => {
    if (this.props.required && this.state.value === "") {
      throw new InputError(this.props.label + " is Required", this.state.value);
    }

    return this.state.value;
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value });

    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  handleBlur = (e) => {
    if (this.props.onBlur) {
      this.props.onBlur(e);
    }

    let newErrorMessage = null;
    if (this.props.validateOnBlur) {
      if (this.props.patternMatch) {
        if (e.target.value && !e.target.value.match(this.props.patternMatch)) {
          newErrorMessage = (this.props.patternMatchError) ?
            this.props.patternMatchError :
            this.props.label + " is not the correct format.";
        }
      }
      if (this.props.required) {
        if (!e.target.value) {
          newErrorMessage = (this.props.requiredError) ?
            this.props.requiredError :
            this.props.label + " is a required field.";
        }
      }
      if (newErrorMessage) {
        this.setState({ className: this.props.validationErrorClass });
      }
      this.setState({
        validationError: newErrorMessage,
        contentWrapperClass: newErrorMessage ? this.props.validationErrorClass : ''
      });
    }
  }

  render() {
    let labelText = this.props.label;

    let label = (this.props.label) ?
      <label htmlFor={this.props.id}>
        {labelText}
      </label> :
      null;

    let inputHelperText = this.props.helperText;

    let helperText = inputHelperText ?
      <span className="helper-text">
        {inputHelperText}
      </span> :
      null;

    let errorText = this.props.errorMessage;
    if (!errorText && this.state.validationError) {
      errorText = this.state.validationError;
    }
    let errorMessage = errorText ?
      <span className="error-message">
        {errorText}
      </span> :
      null;

    let requiredFieldIndicator = (this.props.required) ?
      <abbr title="This field is required"></abbr> :
      null;

    let verticalSpacingClass = this.props.verticalSpacing === "compact" ? "field--compact" : "field";

    let readOnlyContent = (this.props.existingContent) ?
      this.props.existingContent.split("\n").map((paragraph, index) => {
        if (paragraph !== "") {
          return <p key={index}>{paragraph}</p>;
        }
        return null;
      }) :
      null;

    let contentWrapperClass = this.props.contentWrapperClass;
    if (this.state.contentWrapperClass) {
      contentWrapperClass = this.state.contentWrapperClass;
    }


    let ElementType = (this.props.useDiv) ? "div" : "span";
    let textAreaDisplay = (this.props.isEditable) ?

      <ElementType className={contentWrapperClass}>
        <div className="label-wrapper">
          {label}
          {requiredFieldIndicator}
        </div>
        <textarea
          className={this.props.className}
          disabled={this.props.disabled}
          id={this.props.id}
          maxLength={this.props.maxLength}
          minLength={this.props.minLength}
          name={this.props.name}
          onBlur={(e) => this.handleBlur(e)}
          onChange={(e) => this.handleChange(e)}
          placeholder={this.props.placeholderText}
          required={this.props.required}
          value={this.state.value}
        >
        </textarea>
        {helperText}
        {errorMessage}
      </ElementType> :
      <ElementType>
        {label}
        <div className="read-only">
          {readOnlyContent}
        </div>
      </ElementType>;

    return (
      <div className={`${verticalSpacingClass} text-area`}>
        {textAreaDisplay}
      </div>
    );
  }
}

TextArea.defaultProps = {
  isEditable: true
};

TextArea.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  existingContent: PropTypes.string,
  helperText: PropTypes.string,
  id: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.string,
  minLength: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholderText: PropTypes.string,
  required: PropTypes.bool,
  useDiv: PropTypes.bool,
  value: PropTypes.string,
  verticalSpacing: PropTypes.string
}
